import { createReducer, on } from '@ngrx/store';
import * as FuelGasActions from './ktl-fgd-fuel-gas.actions';
import { CalculatedStreamDTO } from 'src/app/web-api-client';

export interface KTLFGDFuelGasState{
  data: CalculatedStreamDTO[] | null ;
  isDailyRecordExistdata: boolean | null;
  lastUpdatedDate: Date | null;
  result: any;
  isLoading: boolean;
  isLoadingSuccess: boolean;
  isLoadingFailure: boolean;
}

const initialState: KTLFGDFuelGasState = {
  data: null,
  isDailyRecordExistdata: null,
  lastUpdatedDate: null,
  result: '',
  isLoading: false,
  isLoadingSuccess: false,
  isLoadingFailure: false,
};

export const KTLFGDFuelGasReducer = createReducer(
  initialState,
  on(FuelGasActions.getDailyFuelGas, (state, result) => ({
    ...state,
    isLoading: true,
  })),
  on(FuelGasActions.getDailyFuelGasSuccess, (state, result) => ({
    ...state,
    data: result.data,
    result,
    isLoading: false,
    isLoadingSuccess: true,
    isLoadingFailure: false,
  })),
  on(FuelGasActions.getDailyFuelGasFailure, (state, result) => ({
    ...state,
    result,
    isLoading: false,
    isLoadingFailure: true,
  })),
  on(FuelGasActions.getDailyUpdatedFuelGas, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(FuelGasActions.getDailyUpdatedFuelGasSuccess, (state, { data }) => ({
    ...state,
    lastUpdatedDate: data,
    isLoading: false,
    isLoadingSuccess: true,
    isLoadingFailure: false,
  })),
  on(FuelGasActions.getDailyUpdatedFuelGasFailure, (state, { message }) => ({
    ...state,
    error: message,
    isLoading: false,
    isLoadingSuccess: false,
    isLoadingFailure: true,
  })),
  on(FuelGasActions.UpdateOxidizersAndCNS, (state, payload) => ({
    ...state,
    isLoading: true,
  })),
  on(FuelGasActions.UpdateOxidizersAndCNSSuccess, (state, payload) => ({
    ...state,
    result: payload,
    isLoading: false,
    isLoadingSuccess: true,
  })),
  on(FuelGasActions.UpdateOxidizersAndCNSFailure, (state, payload) => ({
    ...state,
    result: payload.message,
    isLoading: false,
    isLoadingFailure: true,
  })),
  on(FuelGasActions.AddOverrideManualRecords, (state, payload) => ({
    ...state,
    isLoading: true,
  })),
  on(FuelGasActions.AddOverrideManualRecordsSuccess, (state, payload) => ({
    ...state,
    result: payload,
    isLoading: false,
    isLoadingSuccess: true,
  })),
  on(FuelGasActions.AddOverrideManualRecordsFailure, (state, payload) => ({
    ...state,
    result: payload.message,
    isLoading: false,
    isLoadingFailure: true,
  })),
  on(FuelGasActions.getIsDailyRecordExist, (state, result) => ({
    ...state,
    isLoading: true,
  })),
  on(FuelGasActions.getIsDailyRecordExistSuccess, (state, result) => ({
    ...state,
    isDailyRecordExistdata: result.isDailyRecordExistdata,
    result,
    isLoading: false,
    isLoadingSuccess: true,
    isLoadingFailure: false,
  })),
  on(FuelGasActions.getIsDailyRecordExistFailure, (state, result) => ({
    ...state,
    result,
    isLoading: false,
    isLoadingFailure: true,
  })),
  on(FuelGasActions.DeleteOverrideRecord, (state, result) => ({
    ...state,
    isLoading: true,
  })),
  on(FuelGasActions.DeleteOverrideRecordSuccess, (state, result) => ({
    data: result.data,
    isDailyRecordExistdata: null,
    lastUpdatedDate: null,
    result,
    isLoading: false,
    isLoadingSuccess: true,
    isLoadingFailure: false
  })),
  on(FuelGasActions.DeleteOverrideRecordFailure, (state, result) => ({
    ...state,
    result,
    isLoading: false,
    isLoadingFailure: true,
  })),
  on(FuelGasActions.RefreshRecords , (state, payload) => ({
    ...state,
    isLoading: true,
  })),
  on(FuelGasActions.RefreshRecordsSuccess , (state, payload) => ({
    ...state,
    result: payload,
    isLoading: false,
    isLoadingSuccess: true,
  })),
  on(FuelGasActions.RefreshRecordsFailure, (state, payload) => ({
    ...state,
    result: payload.message,
    isLoading: false,
    isLoadingFailure: true,
  }))
);